@if (items().length) {
  <div class="overflow-hidden rounded-md border border-neutral-100">
    @for (item of items(); track $index) {
      <div class="flex items-center gap-3 border-b border-neutral-100 px-3 py-2 text-sm last:border-b-0">
        <span class="rounded bg-neutral-100 px-2 py-0.5 text-xs text-neutral-500">{{ item.code }}</span>
        <span class="flex-1 text-neutral-700">{{ item.nameUa || item.nameEn }}</span>
        <button
          type="button"
          class="hover:text-error-600 flex items-center text-neutral-400"
          [attr.aria-label]="'protocols.edit.remove' | translate"
          (click)="removeItem.emit($index)"
        >
          <mat-icon style="font-size: 1.1rem; width: 1.1rem; height: 1.1rem">close</mat-icon>
        </button>
      </div>
    }
  </div>
} @else {
  <p class="text-sm text-neutral-400">{{ "protocols.edit.emptySection" | translate }}</p>
}
